import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { LABEL_CLS, ERROR_CLS } from 'helpers/formStyles';

/**
 * FormField — the one label + control + error scaffold. Standardizes the
 * ~200 hand-written red-error paragraphs across forms on ERROR_CLS.
 *
 *   <FormField label="Email" required error={errors.email?.message}>
 *     <Input error={!!errors.email} {...register('email')} />
 *   </FormField>
 *
 * `error` accepts a string (message shown) or boolean (spacing only).
 * `hint` renders muted helper text when there is no error.
 */
const FormField = ({ label, required = false, error, hint, htmlFor, className = '', children }) => (
  <div className={classNames('tw-flex tw-flex-col tw-gap-1', className)}>
    {label && (
      <label htmlFor={htmlFor} className={classNames(LABEL_CLS, 'tw-mb-0')}>
        {label}
        {required && <span className="tw-text-red-500 tw-ml-0.5">*</span>}
      </label>
    )}
    {children}
    {typeof error === 'string' && error ? (
      <p className={ERROR_CLS}>{error}</p>
    ) : (
      hint && <p className="tw-text-xs tw-text-slate-400 tw-mt-1 tw-mb-0">{hint}</p>
    )}
  </div>
);

FormField.propTypes = {
  label: PropTypes.node,
  required: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  hint: PropTypes.node,
  htmlFor: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node
};

export default FormField;
